import React, { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import Select from 'react-select'
import Cookies from 'js-cookie'
import esTexts from '../texts/es.json'
import enTexts from '../texts/en.json'
import PostGrid from '../components/PostGrid/PostGrid'
import { getAllPosts } from '../helpers'
import { DefaultLayout } from '../layouts/default-layout'
import { filterPosts } from '../helpers/filterPosts'
import PropTypes from 'prop-types'

function News({ data }) {
  const [originalPostsList, setOriginalPostsList] = useState([])
  const [postList, setPostList] = useState([])
  const [selectedOption, setSelectedOption] = useState({
    value: 'all',
    label: 'All',
  }) // Adjusted initial state to match expected object structure

  const language = Cookies.get('dpalanguage') || 'es'
  const texts = language === 'es' ? esTexts : enTexts

  const handleChange = (option) => {
    setSelectedOption(option)
  }

  useEffect(() => {
    setOriginalPostsList(getAllPosts(data))
    setPostList(getAllPosts(data))
  }, [data])

  useEffect(() => {
    if (originalPostsList.length > 0) {
      const filteredList = filterPosts(originalPostsList, selectedOption)
      setPostList(filteredList)
    }
  }, [selectedOption, originalPostsList])

  const options = [
    { value: 'all', label: texts.webWords.todas },
    { value: 'grado', label: texts.programasPage.grado },
    { value: 'master-habilitante', label: texts.programasPage.masterHab },
    { value: 'mpaanoticia', label: 'MPAA' },
    { value: 'doctorado', label: texts.programasPage.doctoradoTitle },
    { value: 'video', label: texts.webWords.video },
  ]

  return (
    <DefaultLayout>
      <section className='l-news'>
        <div className='filters'>
          <Select
            value={selectedOption}
            onChange={handleChange}
            options={options}
            className='react-select-container'
            classNamePrefix='react-select'
          />
        </div>
        <PostGrid
          posts={postList}
          selectedOption={selectedOption}
          linkTo='/noticias/'
        />
      </section>
    </DefaultLayout>
  )
}

News.propTypes = {
  data: PropTypes.object,
}

export const query = graphql`
  query {
    allWpPost(
      filter: {
        status: { eq: "publish" }
        categories: { nodes: { elemMatch: { slug: { eq: "post" } } } }
      }
      sort: { date: DESC }
    ) {
      edges {
        node {
          title
          id
          slug
          categories {
            nodes {
              slug
            }
          }
          tags {
            nodes {
              slug
              name
            }
          }
          linkTo
          featuredImage {
            node {
              sourceUrl
              gatsbyImage(
                width: 400
                aspectRatio: 1.78
                formats: AUTO
                placeholder: DOMINANT_COLOR
                quality: 20
              )
            }
          }
        }
      }
    }
  }
`

export default News
